module.exports = "/_next/static/images/recording-359361ea8029f23dbbdb37620d671a25.svg";